export default __webpack_public_path__ + "static/media/Enviro Waste Main Logo.f8df6f0b.png";